
const T = {

    //0 to n-1
    genRand: function (n,max){
        var arr = [];
        while(arr.length < n){
            var r = Math.floor(Math.random() * max);
            if(arr.indexOf(r) === -1) arr.push(r);
        }
        return arr;
    },
    
    shuffleArray: function(array){
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    },

    
    commaLimit: function(str, n){
        // var a = str.split(",");
        // var o = "";
        // for (var i = 0; i < n; i++) {
        //     if(i >= a.length){break;}
        //     if(o != ""){ o += ",";}
        //     o += a[i];
        // }
        // return o;
        return T.splitLimit(",",str, n);
    },

    splitLimit: function(s,str, n){
        var a = str.split(s);
        T.shuffleArray(a);//shuffle
        var o = "";
        for (var i = 0; i < n; i++) {
            if(i >= a.length){break;}
            if(o != ""){ o += ",";}
            o += a[i];
        }
        return o;
    },

    test: function(){
        return ["SS","EE","FF","GGG"];
    }

}

export default T;